<template>
  <div>
    <FullFit v-if="matchStatus === 'FULL FIT'" />
    <NoFit v-else-if="matchStatus === 'NO FIT'" />
    <Raw v-else />
  </div>
</template>

<script>
import FullFit from "./full-fit";
import NoFit from "./no-fit";
import Raw from "./raw";
import { mapGetters } from "vuex";

export default {
  name: "Matcher",
  components: {
    FullFit,
    NoFit,
    Raw
  },
  created() {
    this.$store.commit(
      "ui/SET_LOADING_TEXT",
      this.$t("match-loading-checking")
    );
    this.$store.commit("ui/SET_LOADING", true);
    this.$store
      .dispatch("users/matchUser")
      .then(() => (this.loading = false))
      .catch(() => (this.loading = false));
  },
  data() {
    return {
      loading: true
    };
  },
  computed: {
    ...mapGetters({
      name: "users/getSelfFirstName",
      matchResult: "users/getSelfMatchStatus",
      matchSize: "users/getSelfMatchSize",
      productCombinations: "pageParams/getProductCombinations"
    }),
    matchStatus() {
      if (
        this.matchResult === "FULL FIT" &&
        !this.productCombinations.find(
          c => c.size.toLowerCase() === this.matchSize.toLowerCase()
        )
      ) {
        return "NO FIT";
      }
      return this.matchResult;
    }
  }
};
</script>

<style>
#tailieSizeBlue {
  margin-bottom: 8px;
}
#tailieTitleText {
  margin-bottom: 15px;
}
.overview-page p {
  margin-top: 0;
}
#tailie-size .tailie-size-screen {
  padding: 20px 20px 10px 20px;
}
</style>
